module.exports = __webpack_public_path__ + "static/media/twitch.62bb7565.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/twitch.png
// module id = 31
// module chunks = 0